import { useMutation } from "@tanstack/react-query";
import { postRegisterPush, InputType as RegisterInput } from "../endpoints/push/register_POST.schema";
import { postUnregisterPush, InputType as UnregisterInput } from "../endpoints/push/unregister_POST.schema";

export function useRegisterPush() {
  return useMutation({
    mutationFn: (data: RegisterInput) => postRegisterPush(data),
    onError: (error) => {
      console.error("Failed to register push device:", error);
    },
  });
}

export function useUnregisterPush() {
  return useMutation({
    mutationFn: (data: UnregisterInput) => postUnregisterPush(data),
    onError: (error) => {
      console.error("Failed to unregister push device:", error);
    },
  });
}